import $ from 'jquery';

const isScrolledIntoView = (elem) => {
  const window_top = $(window).scrollTop();
  const window_bottom = window_top + $(window).height();
  const elem_top = $(elem).offset().top;
  const elem_bottom = elem_top + $(elem).height();

  return ((elem_top <= window_bottom) && (elem_bottom >= window_top));
};

const carouselCheck = (elem) => {
  if ($(elem).closest('[data-hero-carousel]').length === 0) {
    // Not in a carousel, all good
    return true;
  }

  if ($(elem).closest('.is-selected').length > 0) {
    // This is a carousel, and the video is in the active carousel slide, all good
    return true;
  }

  return false;
};

export default function(elem) {
  return ($(elem).is(':visible') && isScrolledIntoView(elem) && carouselCheck(elem));
}